export const TOP_THRESHOLD = 20;
export const BOTTOM_PIN_ENTER_PX = 2;
export const BOTTOM_PIN_EXIT_PX = 24;
export const READING_LINE_OFFSET = 120;

export function getDistanceFromBottom(
  scrollTop: number,
  scrollHeight: number,
  clientHeight: number,
): number {
  return scrollHeight - scrollTop - clientHeight;
}

export function updateBottomPinState(
  distanceFromBottom: number,
  isPinnedToBottom: boolean,
): boolean {
  if (distanceFromBottom <= BOTTOM_PIN_ENTER_PX) {
    return true;
  }
  if (isPinnedToBottom && distanceFromBottom <= BOTTOM_PIN_EXIT_PX) {
    return true;
  }
  return false;
}

export interface GetActiveTocHeadingIdParams {
  headingIds: string[];
  headingTops: number[];
  scrollTop: number;
  scrollHeight: number;
  clientHeight: number;
  readingLineY: number;
  isPinnedToBottom: boolean;
}

export interface GetActiveTocHeadingIdResult {
  activeId: string;
  isPinnedToBottom: boolean;
}

export function getActiveTocHeadingId(
  params: GetActiveTocHeadingIdParams,
): GetActiveTocHeadingIdResult {
  const {
    headingIds,
    headingTops,
    scrollTop,
    scrollHeight,
    clientHeight,
    readingLineY,
    isPinnedToBottom: wasPinned,
  } = params;

  if (headingIds.length === 0) {
    return { activeId: '', isPinnedToBottom: false };
  }

  const canScroll = scrollHeight > clientHeight + 1;
  const distanceFromBottom = getDistanceFromBottom(scrollTop, scrollHeight, clientHeight);
  const isPinnedToBottom =
    canScroll && updateBottomPinState(distanceFromBottom, wasPinned);

  if (scrollTop < TOP_THRESHOLD) {
    return { activeId: headingIds[0], isPinnedToBottom };
  }

  if (isPinnedToBottom) {
    return { activeId: headingIds[headingIds.length - 1], isPinnedToBottom };
  }

  let activeId = headingIds[0];
  for (let i = 0; i < headingIds.length; i++) {
    if (headingTops[i] <= readingLineY) {
      activeId = headingIds[i];
    }
  }

  return { activeId, isPinnedToBottom };
}
